<template>
  <div>
    <div class="sr-only">
      Controls for dropdown:
        Arrow keys up and down to select options.
        Space to open/close dropdown.
        Backspace to reset dropdown (Some options require no selection).
    </div>
    <div class="card_container">
      <div class="card" v-for="(card, index) in cards" :key="index">

        <img class="card_container_img" alt="image" aria-hidden="true" :src="require('./assets/' + card.cardImgSrc)" />
        
        <div class="card_container_title">
          <h2>{{ card.cardTitle }}</h2>
        </div>
        <div class="card_container_subtitle">
          <p>{{ card.cardSubtitle }}</p>
        </div>
        <div class="card_container_button">
          <a :href="card.cardButtonLink" target="_blank">
            {{ card.cardButtonText }}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="chevron_right"
              viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <SelectorWidget />
  </div>
</template>

<script>
import { ref } from 'vue';
import SelectorWidget from './components/SelectorWidget.vue';

export default {
  name: 'App',
  components: {
    SelectorWidget
  },
  setup() {
    var cards = ref([
      {
        cardImgSrc: "view_resources.svg",
        cardImgAltText: "",
        cardTitle: "Resources for Teachers and Teacher Educators",
        cardSubtitle: `These materials and courses help develop teaching and learning.`,
        cardButtonText: "VIEW RESOURCES",
        cardButtonLink: "https://www.open.edu/openlearncreate/course/index.php?categoryid=586  "
      },
      {
        cardImgSrc: "audio_visual_resources.svg",
        cardImgAltText: "",
        cardTitle: "Audio-visual resources of classroom practice",
        cardSubtitle: `These help to demonstrate how to become more learner-centred in the classroom.`,
        cardButtonText: "AUDIO-VISUAL RESOURCES",
        cardButtonLink: "https://www.open.edu/openlearncreate/course/index.php?categoryid=587  "
      }
    ]);

    return { cards };
  },
}
</script>

<style>
.sr-only {
position:absolute;
left:-10000px;
top:auto;
width:1px;
height:1px;
overflow:hidden;
}

#app {
  max-width: 720px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
}

.card_container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: center;
  margin: 5px 5px 10px 5px;
}

.card {
  display: flex;
  flex-direction: column;
  flex: 1 1 48%;
  margin: 5px;
  background-color: #e6e6e6;
}

.card_container_img {
  width: 100%;
  height: 15em;
  background-size: cover;
  background-repeat: no-repeat;
}

.card_container_img {
  padding: 1em 3.6em 0em 3.6em;
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.card_container_title,
.card_container_subtitle,
.card_container_button {
  padding: 0px 1em 0px 1em;
}

.card_container_subtitle {
  padding: 0px 1em 1em 1em;
}

.card_container_button {
  margin-top: auto;
  padding-bottom: 1em;
}

.card_container_button a {
  display: inline-block;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.56em;
  background-color: #c80959;
  color: #fff;
  border: 1px solid #c80959;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
}

.card_container_button a:hover,
.card_container_button a:focus {
  color: #aa3f27;
  background-color: #fff;
  border: 1px solid #aa3f27;
}

.chevron_right {
  padding-left: 0.2em;
}
</style>

